import React from 'react'
import Card from '@mui/material/Card';

const About = () => {
  return (
    <Card>
        <h1>About</h1>
    </Card>
  )
}

export default About